import { Video, Clock, Youtube, Monitor } from "lucide-react";

export interface Product {
    id: number;
    name: string;
    descriptionTh: string;
    descriptionEn: string;
    featuresTh: string[];
    featuresEn: string[];
    price: number;
    devices: number;
    icon: React.ReactNode;
    popular?: boolean;
    longDescriptionTh: string;
    longDescriptionEn: string;
    videoUrl?: string;
    imageUrls: string[];
}

export const products: Product[] = [
    {
        id: 1,
        name: "AI Video Pro",
        descriptionTh: "โปรแกรมขยาย VDO Full HD, ตัดขอบดำ, รวมไฟล์, ใส่ลายน้ำ",
        descriptionEn: "Video upscaling to Full HD, crop black bars, merge files, add watermark",
        featuresTh: [
            "ขยายขนาด Video ให้ได้ขนาด Full HD จาก HD ธรรมดา ความชัดเท่าเดิม ทำให้ระบบรู้ว่าเป็นขนาด Full HD",
            "ตัดขอบดำอัตโนมัติ",
            "รวมหลายไฟล์เข้าด้วยกัน",
            "ใส่ลายน้ำแบบกำหนดเอง",
            "รองรับหลายฟอร์แมต"
        ],
        featuresEn: [
            "Upscale video to Full HD quality",
            "Auto crop black bars",
            "Merge multiple files together",
            "Custom watermark support",
            "Multiple format support"
        ],
        longDescriptionTh: "ปลดล็อกขีดจำกัดของวิดีโอคุณด้วย AI Video Pro สุดยอดเครื่องมือสำหรับคนทำวิดีโอที่ต้องการคุณภาพสูงสุดในเวลาที่สั้นที่สุด เพิ่มขนาด VDO เป็นขนาด Full HD พร้อมระบบตัดขอบดำ (Auto Crop) ที่จะทำให้วิดีโอของคุณดูเป็นมืออาชีพทันที ไม่ว่าจะอัปโหลดขึ้น YouTube, TikTok หรือ Facebook",
        longDescriptionEn: "Unlock your video potential with AI Video Pro, the ultimate tool for video creators who demand the highest quality in the shortest time. Featuring AI Upscaling technology to transform low-resolution videos into crisp Full HD, plus Auto Crop to instantly professionalize your content for YouTube, TikTok, or Facebook.",
        price: 1990,
        devices: 2,
        icon: <Video className="h-8 w-8" />,
        popular: true,
        videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
        imageUrls: [
            "https://images.unsplash.com/photo-1492724441997-5dc865305da7?w=800",
            "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?w=800"
        ]
    },
    {
        id: 2,
        name: "Veo3 Auto Extension",
        descriptionTh: "Extension ช่วย Gen Veo3 ตั้งเวลาได้ Download อัตโนมัติ",
        descriptionEn: "Chrome extension for Veo3 with scheduler and auto download",
        featuresTh: [
            "ตั้งเวลา Generate อัตโนมัติ",
            "Download อัตโนมัติเมื่อเสร็จ",
            "จัดคิวงานได้หลายรายการ",
            "แจ้งเตือนเมื่อเสร็จ",
            "ใช้งานง่ายบน Chrome"
        ],
        featuresEn: [
            "Schedule auto generation",
            "Auto download when complete",
            "Queue multiple jobs",
            "Notification when done",
            "Easy to use on Chrome"
        ],
        longDescriptionTh: "ประหยัดเวลาการทำงานด้วย Veo3 Auto Extension ตัวช่วยที่จะทำให้การสร้างวิดีโอของคุณเป็นเรื่องง่ายขึ้น ไม่ต้องมานั่งเฝ้าหน้าจอรอนานๆ อีกต่อไป คุณสามารถตั้งเวลาการ Generate ได้ตามใจชอบ และระบบจะทำการ Download วิดีโอที่เสร็จแล้วลงเครื่องคุณโดยอัตโนมัติ พร้อมระบบ Queue ที่ช่วยให้คุณรันงานได้ต่อเนื่องทั้งวัน",
        longDescriptionEn: "Save time with Veo3 Auto Extension, the tool that simplifies your video generation workflow. No more waiting in front of the screen. Schedule generations as you wish, and the system will automatically download completed videos to your device. The queue system ensures your work keeps running all day long.",
        price: 1490,
        devices: 2,
        icon: <Clock className="h-8 w-8" />,
        imageUrls: [
            "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800",
            "https://images.unsplash.com/photo-1551288049-bbdac8a28a1e?w=800"
        ]
    },
    {
        id: 3,
        name: "YouTube Spy Pro",
        descriptionTh: "ติดตามช่อง/Keyword หา Viral Clip มาใหม่แบบเรียลไทม์",
        descriptionEn: "Track channels/keywords to find new viral clips in real-time",
        featuresTh: [
            "ติดตามช่อง YouTube ได้ไม่จำกัด",
            "ค้นหาด้วย Keyword",
            "แจ้งเตือน Viral Clip ใหม่",
            "วิเคราะห์เทรนด์และสถิติ",
            "Export ข้อมูลได้",
            "ฟรี 10,000 เครดิต (GenCNX)"
        ],
        featuresEn: [
            "Track unlimited YouTube channels",
            "Search by keywords",
            "New viral clip notifications",
            "Trend & stats analysis",
            "Export data",
            "Free 10,000 GenCNX Credits"
        ],
        longDescriptionTh: "ไม่พลาดทุกกระแสที่เป็นไวรัลด้วย YouTube Spy Pro เครื่องมือสอดแนมคอนเทนต์ที่ทรงพลังที่สุด ช่วยให้คุณติดตามช่องคู่แข่งหรือ Keyword ที่สนใจเพื่อหาไอเดียการทำคลิปที่กำลังมาแรงแบบเรียลไทม์ พร้อมระบบแจ้งเตือนเมื่อมีคลิปที่มียอดวิวพุ่งสูงผิดปกติ (Spike) ช่วยให้คุณเกาะกระแสได้ทันก่อนใคร พิเศษ! รับฟรี 10,000 เครดิตสำหรับใช้งาน GenCNX ภายในระบบ",
        longDescriptionEn: "Never miss a viral trend with YouTube Spy Pro, the most powerful content scouting tool. Track competitors or keywords to find trending video ideas in real-time. Features spike notifications for videos with unusually high view growth, allowing you to ride the wave before anyone else. Special! Get 10,000 FREE credits for GenCNX features.",
        price: 19990,
        devices: 2,
        icon: <Youtube className="h-8 w-8" />,
        imageUrls: [
            "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=800",
            "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800"
        ]
    },
    {
        id: 4,
        name: "Custom Automation Program",
        descriptionTh: "ระบบ Automation แบบกำหนดเอง พร้อม Source Code สำหรับธุรกิจ",
        descriptionEn: "Custom automation system with full source code for business",
        featuresTh: [
            "กำหนดระบบได้ตามต้องการ",
            "ระบบซื้อขายอัตโนมัติ",
            "ได้รับ Source Code ทั้งหมด",
            "ปรับแต่งและพัฒนาต่อได้",
            "รองรับการขยายธุรกิจ",
            "ฟรี 50,000 เครดิต (GenCNX)"
        ],
        featuresEn: [
            "Define your own system requirements",
            "Automated trading system",
            "Full source code included",
            "Customizable and extendable",
            "Business scalable",
            "Free 50,000 GenCNX Credits"
        ],
        longDescriptionTh: "ยกระดับธุรกิจของคุณไปอีกขั้นด้วยระบบ Automation แบบสั่งทำพิเศษ ไม่ว่าจะเป็นระบบตัดต่อวิดีโออัตโนมัติ ระบบโพสต์คอนเทนต์ข้ามแพลตฟอร์ม หรือระบบจัดการข้อมูลขนาดใหญ่ เราออกแบบและพัฒนาให้ตามโจทย์ธุรกิจของคุณ พร้อมมอบ Source Code ทั้งหมดให้คุณเป็นเจ้าของ 100% เพื่อความมั่นคงและอิสระในการพัฒนาต่อในอนาคต พิเศษ! รับฟรี 50,000 เครดิตสำหรับใช้งาน GenCNX ภายในระบบ",
        longDescriptionEn: "Take your business to the next level with custom-built automation systems. Whether it's auto-video editing, cross-platform posting, or big data management, we design and develop according to your business needs. Receive full source code and 100% ownership for stability and future development freedom. Special! Get 50,000 FREE credits for GenCNX features.",
        price: 99000,
        devices: 999,
        icon: <Monitor className="h-8 w-8" />,
        imageUrls: [
            "https://images.unsplash.com/photo-1551288049-bbdac8a28a1e?w=800",
            "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800"
        ]
    }
];
